export default __webpack_public_path__ + "static/media/p12.27232344.jpeg";